import { DetailConfigState as _DetailConfigState } from "./reducer";

export {
  default,
  INITIAL_STATE,
  makeInitialState,
  ensureSpaceDetailComponent
} from "./reducer";
export type DetailConfigState = _DetailConfigState;
